// extracted by mini-css-extract-plugin
export var formBtnOuter = "pif-module--formBtnOuter--bd8HP";
export var head = "pif-module--head--TXzrK";
export var root = "pif-module--root--xRjW2";